var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

var SvgPlusDivider = function SvgPlusDivider(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 42,
    viewBox: "0 0 762 42",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pages/Services/ProjectBlock",
    transform: "translate(0 -1064)",
    fill: "#46A4D9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M748 28v14h-14V28h14ZM0 28V14h734v14H0Zm762-14v14h-14V14h14ZM748 0v14h-14V0h14Z",
    transform: "translate(0 1064)",
    id: "Shape"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPlusDivider);
export default ForwardRef;